"use client";

import { useEffect } from "react";
import { trackAnalyticsEvent } from "@/lib/analytics";

/**
 * Drop this into any subscription page (server component).
 *
 * Fires SCREEN_VIEWED_WEB in two cases:
 * 1. On initial/direct page mount (entry_source from sessionStorage or 'direct')
 * 2. Each time the user returns from MockAppUI (via 'alright-screen-returned' CustomEvent)
 *    This covers both thumbnail-click returns and ExitBottomSheet "Start Trial" returns.
 */
export function SubscriptionScreenTracker() {
  useEffect(() => {
    // Case 1: initial / direct page load
    const initialSource =
      sessionStorage.getItem("alright_entry_source") ?? "direct";
    trackAnalyticsEvent("SCREEN_VIEWED_WEB", {
      screen_name: "Subscription_Page",
      entry_source: initialSource,
    });
    sessionStorage.removeItem("alright_entry_source");

    // Case 2: user returns from MockAppUI (fired by BackButtonFrictionOverlay)
    const handleReturn = () => {
      const source =
        sessionStorage.getItem("alright_entry_source") ?? "direct";
      trackAnalyticsEvent("SCREEN_VIEWED_WEB", {
        screen_name: "Subscription_Page",
        entry_source: source,
      });
      sessionStorage.removeItem("alright_entry_source");
    };

    window.addEventListener("alright-screen-returned", handleReturn);
    return () =>
      window.removeEventListener("alright-screen-returned", handleReturn);
  }, []);

  return null;
}
